import React from 'react';
import { motion } from 'framer-motion';
import { FileCodeIcon, SlidersHorizontalIcon, UserCheckIcon, SearchIcon } from 'lucide-react';
const ReliabilityPillar = ({
  icon,
  title,
  items,
  index
}: {
  icon: React.ReactNode;
  title: string;
  items: string[];
  index: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true
}} transition={{
  duration: 0.5,
  delay: index * 0.1
}} className="space-y-3 sm:space-y-4" data-id="element-972">
    <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4" data-id="element-973">
      <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-orange-50 flex items-center justify-center text-orange-600" data-id="element-974">
        {icon}
      </div>
      <h3 className="text-lg sm:text-xl font-bold text-gray-900" data-id="element-975">{title}</h3>
    </div>
    <ul className="space-y-2 sm:space-y-3" data-id="element-976">
      {items.map((item, i) => <li key={i} className="text-gray-600 text-sm leading-relaxed pl-1 border-l-2 border-gray-100 ml-1 pl-3 sm:pl-4" data-id="element-977">
          {item}
        </li>)}
    </ul>
  </motion.div>;
const Reliability = () => {
  return <section className="w-full bg-gray-50 py-16 sm:py-24 md:py-32 lg:py-48 border-y border-gray-100" data-id="element-978">
      <div className="container mx-auto px-4 sm:px-6 md:px-8" data-id="element-979">
        <div className="max-w-4xl mx-auto text-center mb-12 sm:mb-16 md:mb-20" data-id="element-980">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 tracking-tight leading-tight" data-id="element-981">
            Reliability isn't a model upgrade — it's a product layer
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-lg sm:text-xl text-gray-600" data-id="element-982">
            FluidWeb makes execution predictable with platform-level guarantees.
          </motion.p>
        </div>

        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 md:gap-12" data-id="element-983">
          <ReliabilityPillar index={0} icon={<FileCodeIcon size={18} className="sm:w-5 sm:h-5" data-id="element-985" />} title="Contracts" items={['Schema-first interfaces', 'Type-checked outputs', 'Deterministic validation']} data-id="element-984" />
          <ReliabilityPillar index={1} icon={<SlidersHorizontalIcon size={18} className="sm:w-5 sm:h-5" data-id="element-987" />} title="Controls" items={['Tool allowlists + parameter bounds', 'Role-based permissions', 'Rate limits + budget controls']} data-id="element-986" />
          <ReliabilityPillar index={2} icon={<UserCheckIcon size={18} className="sm:w-5 sm:h-5" data-id="element-989" />} title="Verification" items={['Human-in-the-loop approvals', 'Step-level confidence gating', 'Safe degrade to Assist mode']} data-id="element-988" />
          <ReliabilityPillar index={3} icon={<SearchIcon size={18} className="sm:w-5 sm:h-5" data-id="element-991" />} title="Auditability" items={['Trace IDs for every action', 'Audit logs + replay', 'Explainable tool calls']} data-id="element-990" />
        </div>
      </div>
    </section>;
};
export default Reliability;